export default __webpack_public_path__ + "static/media/circle.c4454108.svg";